import type React from 'react';
import { MainContent } from '../../../components/MainContent';
import { LazySheetEditor } from '../../../components/sheet-editor/LazySheetEditor.tsx';
import { useLabSheets } from '../../../hooks/useLabSheets.ts';

export const Sheets: React.FC<{ labId: string }> = ({ labId }) => {
  const { autoSave, loading, sheetData, labParameters } = useLabSheets(labId);

  return (
    <MainContent size="medium">
      <LazySheetEditor
        loading={loading}
        sheets={sheetData}
        onChange={autoSave}
        showLab={false}
        flipParamNames={false}
        parameters={labParameters}
      />
    </MainContent>
  );
};
